import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';

import { dismissShiftAlert, editShiftAlert } from 'actions/notifications';

import {
  enableEditMode,
  showTimecardModal,
} from 'features/timesheets/redux/timecardSlice';

import { df, moment } from 'util/dateTime';
import { toI18n } from 'util/i18n';
import { TRACK_STARTING_PATHS } from 'util/tracking_constants';

import AlertsListItem from '../AlertsListItem';

type ShiftAlertProps = {
  item: ImmutableMap<string, any>;
  descI18n?: string;
};

const ShiftAlert = ({ item, descI18n, ...rest }: ShiftAlertProps) => {
  const dispatch = useDispatch();

  const actualStartDate = moment(item.get('actual_start_date')).format(
    df('msg_time')
  );

  const scheduledStartDate = moment(item.get('scheduled_start_date')).format(
    df('msg_time')
  );

  const formattedFullName = `${item.get('first_name')} ${item.get(
    'last_name'
  )}`;

  const descI18nProps = {
    name: formattedFullName,
    actual_start_at: actualStartDate,
    scheduled_start_at: scheduledStartDate,
  };

  const handleDismiss = useCallback(() => {
    dispatch(dismissShiftAlert(item));
  }, [dispatch, item]);

  const handleEdit = useCallback(() => {
    dispatch(editShiftAlert(item));
  }, [dispatch, item]);

  const handleEditClockOut = useCallback(() => {
    dispatch(
      showTimecardModal(item.get('id'), null, null, {
        startingPath: TRACK_STARTING_PATHS.ALERTS,
      })
    );
    dispatch(enableEditMode('actual_end_at'));
  }, [dispatch, item]);

  const desc = toI18n(descI18n || 'notifications.alerts.default.desc', {
    props: descI18nProps,
  });

  const onEdit =
    item.get('type') === 'clock_out' ? handleEditClockOut : handleEdit;

  return (
    <AlertsListItem
      desc={desc}
      onEdit={onEdit}
      onDismiss={handleDismiss}
      item={item}
      {...rest}
    />
  );
};

export default memo(ShiftAlert);
